
class CapSubmitNewStudentPdf {
  constructor(config) {
    this.config = config
  }

  checkPermission(options = {}) {
    if (options === undefined) {
      return Boolean(this.config)
    }

    if (this.config.schoolYear && options.schoolYear) {
      return this._checkConfigField('schoolYear', options)
    }
    else if (this.config.district && options.district) {
      return this._checkConfigField('district', options)
    }
    else {
      // options is empty
      return Boolean(this.config)
    }
  }

  _checkConfigField(fieldKey, options) {
    if (this.config[fieldKey]) {
      if (options.length === 0) {
        return false
      }
      return this.config[fieldKey].options
        .map(kv => kv.district)
        .some(value => options[fieldKey].includes(value))
    }
    else {
      return false
    }
  }
}

function key() {
  return 'submit_new_student_pdf'
}

function create(config) {
  return new CapSubmitNewStudentPdf(config)
}

export default {
  key,
  create,
}
